import React from "react";
import cn from "classnames";

import { RegularText } from "components/Text";

import styles from "./styles.module.scss";

/**
 * Единый чекбокс с опциональным лейблом.
 * onChange получает boolean.
 */
export const Checkbox = ({
  checked = false,
  onChange,
  label,
  disabled,
  size = 16,
  className,
}) => (
  <label
    className={cn(styles.container, className, {
      [styles.disabled]: disabled,
    })}
  >
    <input
      type="checkbox"
      checked={checked}
      disabled={disabled}
      onChange={(ev) => onChange?.(ev.target.checked)}
      onClick={(ev) => ev.stopPropagation()}
    />
    <span
      className={styles.checkmark}
      style={{ width: size, height: size }}
    />
    {!!label && <RegularText size={13}>{label}</RegularText>}
  </label>
);
